/*eslint-disable */
var $ = window.jQuery = require('jquery');

import { VueEditor } from "vue2-editor";
import draggable from 'vuedraggable'
import {
mapGetters,
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'members-filters-categories',
  components: {
    VueEditor,
    draggable
  },
  props: [],
  data () {
    return {
      submitted:false,
      display_name:'',
      filter_key:'',
      file:null,
      uploadAttachmentName:'',
      createMemberFiltersPopup:false,
      getMemberFiltersListState:{},
      getMemberFiltersListResults:[],
      updateMemberFiltersPopup:false,
      updateMemberFiltersId:'',
      removeMemberFiltersPopup:false,
      removeMemberFiltersId:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
      movedSectionIndex:'',
      movedSectionId:''
    }
  },
  computed: {
    ...mapGetters([
      'getMemberMainFiltersGetters'
    ]),
    getMemberFiltersListFun(){
      this.getMemberFiltersListState = this.$store.getters.getMemberMainFiltersGetters.data;
      return
    },
    getMemerFilterInitialStateFun(){
      if(this.getMemberFiltersListState != undefined){
        this.getMemberFiltersListResults = this.getMemberFiltersListState.results
      }
      return
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    }
  },
  mounted () {
    this.getMemberFiltersListFun
    this.getMemerFilterInitialStateFun
  },
  methods: {
    handleAttachmentUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }else {
        this.uploadAttachmentName = '';
      }
    },
    getMemberFiltersListAgainMethod(){
      this.$store.dispatch('getMemberMainFilterAction').then((res) => {
        this.getMemberFiltersListState = res.data.data
      })
      this.$store.dispatch('getMemberFilterCountFun').then((res)=>{}).catch((err)=>{})
    },
    createMemberFiltersPopupFun(){
      this.createMemberFiltersPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeMemberFiltersPopupFun(){
      this.createMemberFiltersPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    createMemberFilterBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('display_name', this.display_name);
          formData.append('filter_key', this.filter_key);
          formData.append('image', this.file);
          this.$store.dispatch('createMemberMainFilterAction', formData).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.getMemberFiltersListAgainMethod()
            this.closeMemberFiltersPopupFun()
            this.display_name = ''
            this.filter_key = ''
            this.file = null
            this.uploadAttachmentName =  ''
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    updateMemberFiltersPopupEnabledFun(filterId,filterData){
      this.updateMemberFiltersId = filterId
      this.updateMemberFiltersPopup = true
      this.display_name = filterData.display_name
      this.filter_key = filterData.filter_key
      this.uploadAttachmentName = filterData.image.split('/')[6].split('?')[0]
      $('body').addClass('body_right_scroll_remove')
    },
    closeUpdateMemberFiltersPopupFun(){
      this.updateMemberFiltersPopup = false
      this.updateMemberFiltersId = ''
      this.display_name = ''
      this.filter_key = ''
      this.uploadAttachmentName =  ''
      $('body').removeClass('body_right_scroll_remove')
    },
    updateMemberFilterBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('display_name', this.display_name);
          formData.append('filter_key', this.filter_key);
          if(this.file != null){
            formData.append('image', this.file);
          }
          this.$store.dispatch('updateMemberMainFilterAction',{data:{data:formData,id:this.updateMemberFiltersId}}).then((res) => {
            toast.success(res.data.msg);
            this.submitted = false
            this.getMemberFiltersListAgainMethod()
            this.closeUpdateMemberFiltersPopupFun()
          }).catch((err)=>{
            this.submitted = false
            toast.error(err.data.msg);
          })
        }
      })
    },
    removeMemberFiltersPopupEnabledFun(filterId){
      this.removeMemberFiltersId = filterId
      this.removeMemberFiltersPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    closeRemoveMemberFiltersPopupFun(){
      this.removeMemberFiltersPopup = false
      this.removeMemberFiltersId = ''
      $('body').removeClass('body_right_scroll_remove')
    },
    removedMemberFiltersPopupFun(){
      this.$store.dispatch('deleteMemberMainFilterAction',{id:this.removeMemberFiltersId}).then((res) => {
        toast.success(res.data.msg);
        this.getMemberFiltersListAgainMethod()
        this.closeRemoveMemberFiltersPopupFun()
      }).catch((err)=>{
        toast.error(err.data.msg);
      })
    },
    SectionMovedFun({ relatedContext, draggedContext }) {
      this.movedSectionIndex = relatedContext.element.order
      this.movedSectionId = draggedContext.element.id
    },
    SectionMoveDragFun: function() {
      var data = {
        order: this.movedSectionIndex
      }
      this.$store.dispatch('updateINdexOfMemberMainFilterAction',{
        data: {
          data: data,
          id: this.movedSectionId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.getMemberFiltersListAgainMethod();
          toast.success("Filter Index Updated Successfully");
        }
      }).catch((err) => {})
    }
  },
  watch: {
    getMemberFiltersListFun(){
      return this.$store.getters.getMemberMainFiltersGetters
    },
    getMemerFilterInitialStateFun(){
      if(this.getMemberFiltersListState != undefined){
        this.getMemberFiltersListResults = this.getMemberFiltersListState.results
      }
      return
    }
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('body_right_scroll_remove')
    next();
  },
}